import React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import AddIcon from '@mui/icons-material/Add';
import { putProject } from '#action/project/dashboard';
import { fetchProjectDevices, fetchProject, setFormData, setAddedDevices, setRemovedDevices } from '#action/project/devices-popup';
import { setProjectDevices } from '#action/project/projects-paginated';
import { AddDevicesButton as StyledAddDevicesButton, AddButtonLabel } from '#component/device/devices-popup/styles';

const AddDevicesButton = props => {
  const dispatch = useDispatch();
  const {
    selected,
    setSelected,
    project,
    addMode,
    openedFromCreateForm,
    formDataObj,
    setFormDevices,
    formDevices: propsFormDevices
  } = props;
  const {
    newlyAddedDevices,
    removedDevices
  } = useSelector(s => s.projectDevicesPopup, shallowEqual);
  const formDevices = propsFormDevices || formDataObj?.formDevices || [];

  const handleAdd = async () => {
    const { title, beginDate, users, devices, id } = project;
    const selectedIds = selected.map(s => s.id);
    const newDevicesData = [
      ...devices,
      ...selectedIds
    ];

    const data = {
      title,
      beginDate: beginDate.slice(0, 10),
      users,
      devices: newDevicesData
    };

    await dispatch(putProject(id, data));
    await dispatch(fetchProjectDevices(id, addMode));
    await dispatch(fetchProject(id));
    setSelected([]);
    await dispatch(setProjectDevices(id, newDevicesData.length));
  };

  const handleAddFormDevices = async () => {
    const newDevicesData = [
      ...formDevices,
      ...selected
    ];

    const selectedIds = selected.map(s => s.id);
    const newRemovedDevices = removedDevices.filter(d => !selectedIds.includes(d.id));

    await dispatch(setRemovedDevices(newRemovedDevices));
    await dispatch(setAddedDevices([...newlyAddedDevices, ...selected]));

    setFormDevices?.(newDevicesData);

    await dispatch(setFormData(newDevicesData));
    await dispatch(fetchProjectDevices(project?.id, addMode, true));

    setSelected([]);
  };

  return (
    <StyledAddDevicesButton
      size="small"
      color="secondary"
      aria-label="Add devices"
      onClick={openedFromCreateForm ? handleAddFormDevices : handleAdd}
    >
      <AddIcon />
      <AddButtonLabel>{`Add selected (${selected?.length})`}</AddButtonLabel>
    </StyledAddDevicesButton>
  );
};

export default AddDevicesButton;
